import { Text } from 'ui'
import { ShiftSimple } from 'api/shift'
import { formatBillRatePerWorker, isBillRateShift } from 'lib/payment'
import { getPayRate } from './utils'

export function ShiftPayOrBillRate({
  shift,
  shortVersion,
}: {
  shift: ShiftSimple
  shortVersion?: boolean
}) {
  const isBillRate = isBillRateShift(shift)
  const formattedRate = isBillRate
    ? formatBillRatePerWorker(Number(shift.billRate))
    : getPayRate(shift)
  const rateType = isBillRate ? 'Bill Rate' : 'Pay Rate'
  if (shortVersion) {
    // mobile version is rendered as a card so we don't need the type
    // because the label of the field itself is the type
    return <Text>{formattedRate}</Text>
  } else {
    // desktop version is rendered as a table so we need the type because
    // the column header does not show the type of the field
    return (
      <>
        <Text>{formattedRate}</Text>
        <Text fontSize={1} color={'neutrals.300'}>
          {rateType}
        </Text>
      </>
    )
  }
}
